// extracted by mini-css-extract-plugin
export default {"agreement":"SignUp_agreement__-cPVH"};